import { IFederatedLoginForm, IFederatedLoginPayload, IFederatedLoginResponse } from './types';

export const INITIAL_FORM_DATA: IFederatedLoginForm = {
  jiraTicket: '',
  summary: '',
  apiKey: '',
};

export const validateForm = (formData: IFederatedLoginForm): boolean => {
  return (
    formData.jiraTicket.trim().length > 0 &&
    formData.summary.trim().length > 0 &&
    formData.summary.length <= 250 &&
    formData.apiKey.trim().length > 0
  );
};

export const buildPayload = (formData: IFederatedLoginForm): IFederatedLoginPayload => {
  const jiraTicket = formData.jiraTicket.trim();
  const summary = formData.summary.trim();
  const apiKey = formData.apiKey.trim();

  return {
    jiraTicket,
    jira_ticket: jiraTicket,
    summary,
    apiKey,
    api_key: apiKey,
  };
};

export const extractLoginUrl = (res: IFederatedLoginResponse | any): string | null => {
  if (!res) return null;
  if (typeof res === 'string' && (res.startsWith('http://') || res.startsWith('https://'))) {
    return res;
  }
  return res.loginUrl || res.loginURL || res.url || res.login_url || null;
};
